/**
 * User-facing support ticket copy.
 */
export const support = {
  title: 'Support',
  subtitle: 'Get help from our team',
  newTicket: 'New ticket',
  myTickets: 'My tickets',
  empty: 'You have not submitted any support tickets yet.',
  loadError: 'Failed to load tickets.',
  submitSuccess: 'Your ticket has been submitted.',
  submitError: 'Failed to submit ticket.',
  commentSuccess: 'Comment added.',
  commentError: 'Failed to add comment.',
  backToList: 'Back to tickets',
  notFound: 'Ticket not found.',
  categories: {
    account_access: 'Account access',
    billing: 'Billing',
    technical: 'Technical issue',
    privacy_security: 'Privacy & security',
    moderation_appeal: 'Moderation appeal',
    general: 'General',
  },
  subcategories: {
    account_access: {
      login_issues: 'Login issues',
      account_recovery: 'Account recovery',
      two_factor_auth: 'Two-factor authentication',
    },
    billing: {
      subscription: 'Subscription',
      payments: 'Payments',
      refunds: 'Refunds',
    },
    technical: {
      bugs: 'Bug report',
      performance: 'Performance',
      compatibility: 'Compatibility',
    },
    privacy_security: {
      data_request: 'Data request',
      unauthorized_access: 'Unauthorized access',
      safety_concern: 'Safety concern',
    },
    moderation_appeal: {
      content_removal: 'Content removal',
      account_action: 'Account action',
      identity_restriction: 'Alias restriction',
    },
    general: {
      feedback: 'Feedback',
      feature_request: 'Feature request',
      other: 'Other',
    },
  },
  status: {
    open: 'Open',
    in_progress: 'In progress',
    escalated: 'Escalated',
    resolved: 'Resolved',
    closed: 'Closed',
  },
  form: {
    category: 'Category',
    categoryPlaceholder: 'Select a category',
    subcategory: 'Subcategory',
    subcategoryPlaceholder: 'Select a subcategory',
    title: 'Title',
    titlePlaceholder: 'Brief summary of your issue',
    body: 'Description',
    bodyPlaceholder: 'Describe your issue. Basic markdown is supported (**bold**, *italic*, lists).',
    attachments: 'Attachments',
    attachmentsHint: 'Up to 5 images or videos (10 MB each).',
    addAttachment: 'Add attachment',
    removeAttachment: 'Remove',
    submit: 'Submit ticket',
    charsRemaining: '{{count}} characters remaining',
    comment: 'Add a comment',
    commentPlaceholder: 'Write a reply…',
    sendComment: 'Send',
  },
  detail: {
    ticketId: 'Ticket ID',
    status: 'Status',
    category: 'Category',
    created: 'Submitted',
    assignedTo: 'Assigned to',
    unassigned: 'Unassigned',
    timeline: 'Conversation',
    noComments: 'No comments yet.',
    you: 'You',
    staff: 'Support Staff',
    statusChanged: 'Status updated',
    assignedToStaff: 'Assigned to {{name}}',
    unassignedEvent: 'Unassigned',
    markResolved: 'Mark as resolved',
    resolveNoteLabel: 'Resolution note (optional)',
    resolveNotePlaceholder: 'Briefly describe why this is resolved…',
    confirmResolve: 'Resolve ticket',
  },
  resolveError: 'Failed to resolve ticket.',
  markdown: {
    write: 'Write',
    preview: 'Preview',
    nothingToPreview: 'Nothing to preview.',
  },
  notifications: {
    ticketReply: 'New reply on your support ticket',
    ticketReplyBody: 'New reply on "{{title}}"',
    ticketUserReply: 'New reply on assigned support ticket',
    ticketUserReplyBody: 'New reply on "{{title}}"',
    ticketAssigned: 'Support ticket assigned to you',
    ticketAssignedBody: 'Assigned: "{{title}}"',
    ticketNewUnassigned: 'New unassigned support ticket',
    ticketNewUnassignedBody: 'New ticket: "{{title}}"',
  },
} as const;
